import { firmClientKeys } from '../FirmClient';

export const financialGoalKeys = {
  financialGoals: (householdID?: string) => [
    'financialGoals',
    ...firmClientKeys.household(householdID),
  ],
};
